import React, { useState } from 'react';

export default function About() {
  const [myStyle, setMyStyle] = useState({
    color: 'black',
    backgroundColor: 'white',
  });

  const [btnText, setBtnText] = useState('Enable Dark Mode');

  const toggleStyle = () => {
    if (myStyle.color === 'black') {
      setMyStyle({
        color: 'white',
        backgroundColor: '#212529',
        border: '1px solid white',
      });
      setBtnText('Enable Light Mode');
    } else {
      setMyStyle({
        color: 'black',
        backgroundColor: 'white',
      });
      setBtnText('Enable Dark Mode');
    }
  };

  return (
    <div className="container my-4" style={myStyle}>
      <h2 className="my-3 text-center">About TextUtils</h2>
      <p className="lead">
        TextUtils is a simple yet powerful text manipulation tool that helps you analyze, edit, and format your text efficiently. Whether you need to count words, convert cases, remove extra spaces, or copy text with ease, TextUtils is your go-to application.
      </p>

      <div className="accordion" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button"
              style={myStyle}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Features of TextUtils
            </button>
          </h2>
          <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
            <div className="accordion-body" style={myStyle}>
              <ul>
                <li>Instant word and character count</li>
                <li>Convert text to uppercase or lowercase</li>
                <li>Remove extra spaces</li>
                <li>Copy text with a single click</li>
                <li>Dark mode support for better readability</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              style={myStyle}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Why Use TextUtils?
            </button>
          </h2>
          <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
            <div className="accordion-body" style={myStyle}>
              <p>
                TextUtils provides a fast and convenient way to edit and analyze text directly from your browser. Whether you are a student, writer, or developer, this tool saves time and effort while improving text clarity.
              </p>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              style={myStyle}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              About the Developer
            </button>
          </h2>
          <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
            <div className="accordion-body" style={myStyle}>
              <p>
                TextUtils was built with React and Bootstrap to provide a seamless and user-friendly text editing experience. If you have suggestions or feedback, feel free to reach out!
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container my-4 text-center">
        <button onClick={toggleStyle} type="button" className="btn btn-primary">
          {btnText}
        </button>
      </div>
    </div>
  );
}
